/** @jsxImportSource @emotion/react */
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { AttendanceNumbers } from '@sportninja/common/types/PlayerAttendance'
import {
  attendanceCounterContainerStyle,
  titleAndTextContainerStyle,
  separatorStyle,
  counterTitleStyle,
  counterTextStyle,
} from '../styles'

/**
 * Props for the AttendanceCounter component
 */
export interface AttendanceCounterProps {
  /** Attendance counts broken down by status */
  attendanceNumbers: AttendanceNumbers
}

/**
 * Displays a color-coded attendance summary with Yes, Maybe, No, and Unknown counts.
 * Each status is separated by a vertical divider.
 *
 * @param {AttendanceCounterProps} props - Component props
 * @returns {JSX.Element} Attendance counter display
 */
const AttendanceCounter: React.FC<AttendanceCounterProps> = ({
  attendanceNumbers,
}) => {
  return (
    <div css={attendanceCounterContainerStyle}>
      <div css={titleAndTextContainerStyle}>
        <p css={counterTitleStyle(colors.SUCCESS_200)}>Yes</p>
        <p css={counterTextStyle(colors.SUCCESS_200)}>
          {attendanceNumbers?.accepted}
        </p>
      </div>
      <div css={separatorStyle} />
      <div css={titleAndTextContainerStyle}>
        <p css={counterTitleStyle(colors.WARNING_200)}>Maybe</p>
        <p css={counterTextStyle(colors.WARNING_200)}>
          {attendanceNumbers?.tentative}
        </p>
      </div>
      <div css={separatorStyle} />
      <div css={titleAndTextContainerStyle}>
        <p css={counterTitleStyle(colors.ERROR_200)}>No</p>
        <p css={counterTextStyle(colors.ERROR_200)}>
          {attendanceNumbers?.declined}
        </p>
      </div>
      <div css={separatorStyle} />
      <div css={titleAndTextContainerStyle}>
        <p css={counterTitleStyle(colors.NEUTRAL_100)}>Unknown</p>
        <p css={counterTextStyle(colors.NEUTRAL_100)}>
          {attendanceNumbers?.unknown}
        </p>
      </div>
    </div>
  )
}

export default React.memo(AttendanceCounter)
